import React from 'react';
import { GetLendingSupportDealFinanceOfferResponse } from '../../hooks/services';

interface Props {
  dealFinanceOffers?: GetLendingSupportDealFinanceOfferResponse;
}

export const LendingSupportUpstartAdminLinks: React.FC<Props> = React.memo(
  ({ dealFinanceOffers }) => {
    const adminBaseUrl = process.env.REACT_APP_UPSTART_ADMIN_URL;

    const getUpstartApplicationId = (): string | undefined => {
      const selectedCreditApp = dealFinanceOffers?.find((app) =>
        app.financeResponses.some((res) => res.isSelected),
      );
      const provider = selectedCreditApp?.provider;
      if (provider?.id === 'upstart') {
        return provider.applicationId;
      }
      return undefined;
    };

    const upstartApplicationId = getUpstartApplicationId();
    if (!upstartApplicationId || !adminBaseUrl) {
      return null;
    }

    return (
      <>
        <div>Upstart Links</div>
        <div>
          <a
            href={`${adminBaseUrl}/admin/applications/${upstartApplicationId}`}
            target={`upstartAdminDashboard-${upstartApplicationId}`}
            rel="noopener noreferrer"
          >
            Upstart Admin Dashboard
          </a>
          <div>(For selected finance response)</div>
        </div>
      </>
    );
  },
);
